<template>
  <div class="nameDetailPage">
    <div class="treatplan" v-for="model in moList" v-if="model.ExecuteState!=6">
      <div>
        <p class="treatname">
          <!--<img src="../../assets/images/treat.png" alt>-->
          <span>{{model.MoName}}</span>
        </p>
        <div class="pt10">
          <p>
            <span>执行状态：</span>
            <span>{{model.ExecuteState | executeStateFilters}}</span>
          </p>
          <p>
            <span>执行时间：</span>
            <span>{{model.ExecuteDate}}</span>
          </p>
          <p>
            <span>治疗师：</span>
            <span>{{model.ExecuteUserName}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { GetTreatedRecord } from "@/services/getData.js";
  import weui from "weui.js";
  export default {
    name: "treatment-namedeteil",
    created: function () {
      this.getTreatedRecord();
    },
    data() {
      return {
        moID: this.$route.query.moID,
        visitID: this.$route.query.visitID,
        moList: {}
      }
    },
    methods: {
      getTreatedRecord() {
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        GetTreatedRecord(this.visitID, this.moID).then((response) => {
          loading.hide();
          if (response.data.Result) {
            this.moList = response.data.Extend;
          }
          else {
            weui.dialog({
              title: "提示",
              content: response.data.Content
            });
          }
        });
      }
    },
    filters: {
      executeStateFilters: function (value) {
        switch (value) {
          case 0:
            return "未执行";
          case 1:
            return "新建";
          case 2:
            return "执行中";
          case 3:
            return "已执行";
          case 5:
            return "未做";
          case 6:
            return "已撤销";
          default:
            return "";
        }
      }
    }
  };
</script>
<style>
  .nameDetailPage {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

    .nameDetailPage .treatplan {
      box-sizing: border-box;
      padding: 0 0.2rem;
      background: white;
      margin-bottom: 0.2rem;
    }

      .nameDetailPage .treatplan > div {
        font-size: 0.24rem;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .nameDetailPage .treatplan img {
        width: 0.28rem;
        height: 0.3rem;
        display: inline-block;
        vertical-align: sub;
        margin-right: 0.1rem;
      }

      .nameDetailPage .treatplan .treatname {
        height: 0.6rem;
        line-height: 0.6rem;
        border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
      }

      .nameDetailPage .treatplan .nameDetail {
        float: right;
        color: #1592e4;
      }

      .nameDetailPage .treatplan .number {
        display: flex;
        flex-direction: row;
        line-height: 0.42rem;
      }

        .nameDetailPage .treatplan .number > div {
          flex: 1;
        }

  .plandeteilpage .treatplan .number .corbule {
    color: #1592e4;
  }

  .nameDetailPage .treatplan .pt10 {
    padding: 0.15rem 0;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/treatment/treatment-namedeteil.vue